import { ConfigServiceProvider } from '../config/config.service';
import { DictionaryItem } from '../../interfaces/dictionary-item.interface';
import { FormField } from '../../interfaces/form-field.interface';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { ContentPage } from '../../interfaces/content-page.interface';
import { Utils } from '../../utils/utils.class';
import { ReferenceField } from '../../interfaces/reference-field.interface';

@Injectable()
export class DataSourceOptionsService {
  constructor(@Inject(ConfigServiceProvider) private confService: ConfigServiceProvider, @Inject(HttpClient) private http: HttpClient) {}

  public downloadFieldsOptions(fields: FormField[], backendBaseAPI: string): void {
    if (!backendBaseAPI || !fields) {
      console.error('DataSourceOptionsService: fields or backendBaseAPI is missing');
      return;
    }

    fields.forEach((field: FormField) => this.downloadFieldOptions(field, backendBaseAPI));
  }

  private downloadFieldOptions(field: FormField, backendBaseAPI: string): void {
    if (field.dataSource === 'dataView' || field.type === 'reference') {
      this.getReferenceValue(field, backendBaseAPI);
    } else if ((field.dataSource === 'dictionary' || field.type === 'dictionary') && field.dictionaryId) {
      this.getDictionaryItemValues(field, backendBaseAPI);
    } else if (field.type === 'list') {
      this.downloadFieldsOptions(field.subForm.definition, backendBaseAPI);
    }
  }

  private getReferenceValue(field: FormField, backendBaseAPI: string): void {
    this.http
      .get<ContentPage>(this.confService.getUrlWithParameter(backendBaseAPI, 'dataView', field.dataView, field.sort))
      .pipe(take(1))
      .subscribe(
        (data: ContentPage) =>
          (field.values = data.content
            .map((elem) => Utils.evaluateReferenceDisplayStrings(elem, field))
            .sort((a, b) => this.sortReferenceFields(a, b, field))),
        (error) => console.error(error),
      );
  }

  private sortReferenceFields(a: ReferenceField, b: ReferenceField, field: FormField): number {
    if (field.rowFormat) {
      return this.sortReferenceFieldsByRowFormatTitle(a, b);
    }
    if (field.dataViewColumn) {
      return this.sortReferenceFieldsByDataViewColumn(a, b);
    }
    throw new Error('[DataSourceOptionsService] Missing ReferenceField display configuration!');
  }

  private sortReferenceFieldsByRowFormatTitle(a: ReferenceField, b: ReferenceField): number {
    if (a.rowFormat.title < b.rowFormat.title) {
      return -1;
    }
    if (a.rowFormat.title > b.rowFormat.title) {
      return 1;
    }
    return 0;
  }

  private sortReferenceFieldsByDataViewColumn(a: ReferenceField, b: ReferenceField): number {
    if (a.dataViewColumn < b.dataViewColumn) {
      return -1;
    }
    if (a.dataViewColumn > b.dataViewColumn) {
      return 1;
    }
    return 0;
  }

  private getDictionaryItemValues(field: FormField, backendBaseAPI: string): void {
    this.http
      .get<DictionaryItem[]>(this.confService.getUrlWithParameter(backendBaseAPI, 'definition', field.dictionaryId, field.sort))
      .pipe(take(1))
      .subscribe(
        (values: DictionaryItem[]) => (field.values = values.sort((a, b) => this.sortDictionaryItems(a, b))),
        (error) => console.error(error),
      );
  }

  private sortDictionaryItems(a: DictionaryItem, b: DictionaryItem): number {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/services/data-source-options/data-source-options.service.ts